module.exports = __webpack_public_path__ + "img/geomembranaPead3.32d6ea03.jpg";